export default __webpack_public_path__ + "static/media/PastedImage.170ea2b7.png";